import { mapDepartment } from '@webapp/core/data-access/mappers/mapDepartment'
import { mapLocation } from '@webapp/core/data-access/mappers/mapLocation'
import { mapOrderDraftItemApiModel } from './mapOrderDraftItemApiModel'
import { mapOrderPunchOutSupplier } from './mapOrderPunchOutSupplier'
import { type AttachmentExtractionStatusEnum } from '../../entities/enums/AttachmentExtractionStatusEnum'
import { type OrderDraftConstructorData } from '../../entities/OrderDraft'
import { type OrderDraftApiModel } from '../api-models/OrderDraftApiModel'

export const mapOrderDraftApiModel = (
  order: OrderDraftApiModel,
  attachmentExtractionStatus: Nullable<AttachmentExtractionStatusEnum>
): OrderDraftConstructorData => ({
  uuid: order.uuid,
  id: order.id,
  dateModified: order.date_modified,
  dateRequired: order.date_required,
  primaryCategory: order.branch ? mapLocation(order.branch) : null,
  secondaryCategory: order.department ? mapDepartment(order.department) : null,
  description: order.description,
  totalCost: order.total_price,
  totalCostInBaseCurrency: order.total_cost_in_base_currency,
  punchoutGroup: order.punchout_group,
  punchoutShippingAddress: order.punchout_shipping_address,
  punchoutSupplier: mapOrderPunchOutSupplier({
    punchout_supplier_icon: order.punchout_supplier_icon,
    punchout_supplier_name: order.punchout_supplier_name,
    punchout_vendor_reference: order.punchout_vendor_reference,
  }),
  items: order.order_items?.map(mapOrderDraftItemApiModel) || [],
  extractionStatus: attachmentExtractionStatus,
})
